import React from "react";

const GlobalLoader = ({ fullScreen = false }) => {
  return (
    <div
      className={`flex flex-col justify-center items-center gap-4 ${
        fullScreen ? "min-h-[80vh]" : "py-16 w-full"
      }`}
    >
      <div className="relative flex justify-center items-center mt-4">
        {/* Outer pulsing ring */}
        <div className="absolute w-16 h-16 border-4 border-orange-500/20 rounded-full animate-ping" />
        {/* Spinning ring */}
        <div className="absolute w-12 h-12 border-4 border-orange-500 rounded-full border-t-transparent animate-spin" />
        {/* Inner dot */}
        <div className="w-3 h-3 bg-orange-500 rounded-full animate-pulse" />
      </div>
      <p className="text-xs font-bold text-orange-600/70 uppercase tracking-[0.3em] animate-pulse mt-4">
        Loading
      </p>
    </div>
  );
};

export default GlobalLoader;
